var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tac",staticStyle:{"background":"#FFFFFF"}},[_c('img',{attrs:{"src":require("../../assets/img/brand-logo.jpg"),"alt":""}})])])
}]

export { render, staticRenderFns }